export default __webpack_public_path__ + "static/media/checked_white.710de4c0.svg";